import { useSelector } from 'react-redux';

const sessionSelect = (state: any) => state.session;
export const useSession = (): any => useSelector(sessionSelect);

const masterAccountIdSelect = (state: any) => state.session?.organization?.masterAccountId;
export const useMasterAccountId = (): string => useSelector(masterAccountIdSelect);
